// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1AoSd","item":"PaymentsMobile_item__7C2UD","label":"PaymentsMobile_label__1rzjX","amount":"PaymentsMobile_amount__1Lhd5"};